import { render } from "./SelectWalletPage.vue?vue&type=template&id=1b0065a9&scoped=true"
import script from "./SelectWalletPage.vue?vue&type=script&lang=js"
export * from "./SelectWalletPage.vue?vue&type=script&lang=js"

import "./SelectWalletPage.vue?vue&type=style&index=0&id=1b0065a9&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0065a9"]])

export default __exports__